import React, { useState } from 'react';
import { SearchIcon, PlusIcon, EditIcon, TrashIcon, EyeIcon } from 'lucide-react';
import { CouponDetailModal } from '../components/CouponDetailModal';
const coupons = [{
  id: 1,
  code: 'RAHAGENT',
  type: 'Fixed Amount',
  services: 'All',
  discount: 25,
  proPercentage: 0,
  realEstreamPercentage: 100,
  usageCount: 16
}, {
  id: 2,
  code: 'Baher',
  type: 'Fixed Amount',
  services: 'All',
  discount: 85,
  proPercentage: 100,
  realEstreamPercentage: 0,
  usageCount: 1
}, {
  id: 3,
  code: 'Irene',
  type: 'Fixed Amount',
  services: 'All',
  discount: 85,
  proPercentage: 100,
  realEstreamPercentage: 0,
  usageCount: 1
}, {
  id: 4,
  code: 'smsm',
  type: 'Fixed Amount',
  services: 'All',
  discount: 25,
  proPercentage: 0,
  realEstreamPercentage: 100,
  usageCount: 1
}, {
  id: 5,
  code: 'RAH',
  type: 'Fixed Amount',
  services: 'Photography',
  discount: 190.97,
  proPercentage: 0,
  realEstreamPercentage: 100,
  usageCount: 1
}, {
  id: 6,
  code: '$25',
  type: 'Fixed Amount',
  services: 'All',
  discount: 25,
  proPercentage: 0,
  realEstreamPercentage: 0,
  usageCount: 1
}, {
  id: 7,
  code: 'Cleaning',
  type: 'Fixed Amount',
  services: 'Home Cleaning',
  discount: 100,
  proPercentage: 0,
  realEstreamPercentage: 100,
  usageCount: 0
}, {
  id: 8,
  code: 'ESTREAM200',
  type: 'Fixed Amount',
  services: 'Photography',
  discount: 200,
  proPercentage: 0,
  realEstreamPercentage: 100,
  usageCount: 0
}, {
  id: 9,
  code: 'Johnny',
  type: 'Fixed Amount',
  services: 'Photography',
  discount: 200,
  proPercentage: 0,
  realEstreamPercentage: 100,
  usageCount: 0
}];
export const CouponsPage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const itemsPerPage = 25;
  const filteredCoupons = coupons.filter(coupon => coupon.code.toLowerCase().includes(searchQuery.toLowerCase()) || coupon.services.toLowerCase().includes(searchQuery.toLowerCase()));
  const handleViewCoupon = coupon => {
    setSelectedCoupon(coupon);
    setIsModalOpen(true);
  };
  const handleAddCoupon = () => {
    setSelectedCoupon(null);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedCoupon(null);
  };
  return <div className="p-6 h-full flex flex-col" data-id="element-585">
      <div className="mb-6" data-id="element-586">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-587">Coupon</h1>
      </div>
      <div className="bg-white rounded-lg shadow border border-gray-100 flex-1 flex flex-col" data-id="element-588">
        <div className="p-4 border-b border-gray-200" data-id="element-589">
          <div className="flex items-center space-x-2" data-id="element-590">
            <button onClick={handleAddCoupon} className="p-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-591">
              <PlusIcon size={18} className="text-gray-600" data-id="element-592" />
            </button>
            <button className="p-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-593">
              <EditIcon size={18} className="text-gray-600" data-id="element-594" />
            </button>
            <button className="p-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-595">
              <TrashIcon size={18} className="text-gray-600" data-id="element-596" />
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-auto" data-id="element-597">
          <table className="w-full" data-id="element-598">
            <thead className="bg-gray-50 border-b border-gray-200 sticky top-0" data-id="element-599">
              <tr data-id="element-600">
                <th className="px-4 py-3 text-left" data-id="element-601">
                  <input type="checkbox" className="rounded" data-id="element-602" />
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 tracking-wider" data-id="element-603">
                  Code
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 tracking-wider" data-id="element-604">
                  Type
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 tracking-wider" data-id="element-605">
                  Service(s)
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 tracking-wider" data-id="element-606">
                  Discount
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 tracking-wider" data-id="element-607">
                  Pro Percentage
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 tracking-wider" data-id="element-608">
                  Real Estream Percentage
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 tracking-wider" data-id="element-609">
                  Number of usage to coupon list
                </th>
                <th className="px-4 py-3" data-id="element-610"></th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-611">
              {filteredCoupons.map(coupon => <tr key={coupon.id} className="hover:bg-gray-50" data-id="element-612">
                  <td className="px-4 py-3" data-id="element-613">
                    <input type="checkbox" className="rounded" data-id="element-614" />
                  </td>
                  <td className="px-4 py-3" data-id="element-615">
                    <span className="text-sm text-gray-900" data-id="element-616">{coupon.code}</span>
                  </td>
                  <td className="px-4 py-3" data-id="element-617">
                    <span className="text-sm text-gray-700" data-id="element-618">{coupon.type}</span>
                  </td>
                  <td className="px-4 py-3" data-id="element-619">
                    <span className="text-sm text-gray-700" data-id="element-620">
                      {coupon.services}
                    </span>
                  </td>
                  <td className="px-4 py-3" data-id="element-621">
                    <span className="text-sm text-gray-900" data-id="element-622">
                      $ {coupon.discount}
                    </span>
                  </td>
                  <td className="px-4 py-3" data-id="element-623">
                    <span className="text-sm text-gray-900" data-id="element-624">
                      $ {coupon.proPercentage}
                    </span>
                  </td>
                  <td className="px-4 py-3" data-id="element-625">
                    <span className="text-sm text-gray-900" data-id="element-626">
                      $ {coupon.realEstreamPercentage}
                    </span>
                  </td>
                  <td className="px-4 py-3" data-id="element-627">
                    <span className="text-sm text-gray-900" data-id="element-628">
                      {coupon.usageCount}
                    </span>
                  </td>
                  <td className="px-4 py-3" data-id="element-629">
                    <button onClick={() => handleViewCoupon(coupon)} className="p-1 hover:bg-gray-100 rounded text-blue-600" data-id="element-630">
                      <EyeIcon size={18} data-id="element-631" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="p-4 border-t border-gray-200 flex items-center justify-end space-x-4" data-id="element-632">
          <span className="text-sm text-gray-600" data-id="element-633">
            1-{filteredCoupons.length} of {filteredCoupons.length}
          </span>
          <div className="flex items-center space-x-2" data-id="element-634">
            <button className="p-1 hover:bg-gray-100 rounded disabled:opacity-50" disabled data-id="element-635">
              <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-636">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" data-id="element-637" />
              </svg>
            </button>
            <button className="p-1 hover:bg-gray-100 rounded disabled:opacity-50" disabled data-id="element-638">
              <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-639">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-640" />
              </svg>
            </button>
          </div>
          <select className="px-3 py-1 border border-gray-300 rounded text-sm" data-id="element-641">
            <option data-id="element-642">25 / page</option>
            <option data-id="element-643">50 / page</option>
            <option data-id="element-644">100 / page</option>
          </select>
        </div>
      </div>
      <CouponDetailModal isOpen={isModalOpen} onClose={handleCloseModal} coupon={selectedCoupon} data-id="element-645" />
    </div>;
};